import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from 'react-error-boundary';
import "../src/styles/index.css";
import App from "./App";
import InternalError from "./components/pages/error/InternalError";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <ErrorBoundary FallbackComponent={InternalError}  onReset={() => (window.location.href = '/dashboard')}> */}
    <ErrorBoundary FallbackComponent={InternalError}>
    <App />
    </ErrorBoundary>
  </React.StrictMode>
);

